/**
 * Gift page "by console" (sections/hhl-gift-consoles.liquid, styles in assets/hhl-gifts.css): <hhl-gift-consoles>.
 * Console buttons: one at a time; the picks fade out and the next fade in. Arrow keys move between buttons.
 * Reduced motion: the picks change at once.
 */
if (!customElements.get('hhl-gift-consoles')) {
  customElements.define('hhl-gift-consoles', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.show(tab));
        tab.addEventListener('keydown', (event) => {
          const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
          if (!step) return;
          event.preventDefault();
          const next = this.tabs[(index + step + this.tabs.length) % this.tabs.length];
          next.focus();
          this.show(next);
        });
      });
    }

    show(tab) {
      if (tab.getAttribute('aria-selected') === 'true') return;
      // Store analytics (assets/custom.js, above hhlTrack): only a shopper's pick calls show()
      if (HHL.track) HHL.track('hhl_gift_console_chosen', { console: tab.textContent.trim() });
      const next = document.getElementById(tab.getAttribute('aria-controls'));
      const current = this.querySelector('.hhl-gift-consoles__panel:not([hidden])');
      this.tabs.forEach((item) => {
        const on = item === tab;
        item.setAttribute('aria-selected', String(on));
        item.tabIndex = on ? 0 : -1;
      });
      const reveal = () => {
        if (current) current.hidden = true;
        next.hidden = false;
        requestAnimationFrame(() => next.classList.add('is-shown'));
      };
      if (!current || HHL.mq.reducedMotion.matches) {
        if (current) current.classList.remove('is-shown');
        reveal();
        return;
      }
      current.classList.remove('is-shown');
      clearTimeout(this._timer);
      this._timer = setTimeout(reveal, 160);
    }
  });
}
